import { render, staticRenderFns } from "./Forgot-Password.vue?vue&type=template&id=53ded995&scoped=true"
import script from "./Forgot-Password.vue?vue&type=script&lang=js"
export * from "./Forgot-Password.vue?vue&type=script&lang=js"
import style0 from "./Forgot-Password.vue?vue&type=style&index=0&id=53ded995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ded995",
  null
  
)

export default component.exports